import { Icon } from '@components';
import { useScreenSize } from '@hooks';
import { Flex, Link, theme, Typography } from '@styles';
import { ReactComponent as LinkIcon } from '@svgs/link.svg';
import { arrayOf, shape, string } from 'prop-types';
import React, { useMemo } from 'react';

const LiteratureList = ({ literature }) => {
  const { isTabletLG, isTabletSM } = useScreenSize();

  const literatureList = useMemo(() =>
    literature.map((literatureItem, index) => (
      <Flex key={literatureItem.id} flexDirection="row" width="100%">
        <Typography
          color={theme.colors.white[100]}
          mr={24}
          variant="MS-regular-s18-lh28"
        >{`${index + 1}`}</Typography>
        <Link
          alignItems="center"
          display="flex"
          target="_blank"
          to={literatureItem.link}
        >
          <Typography
            color={theme.colors.white[100]}
            variant="MS-regular-s18-lh28"
          >
            {literatureItem.titleText}
          </Typography>
          <Icon
            color={theme.colors.schoolBusYellow[100]}
            ml={24}
            SVG={LinkIcon}
          />
        </Link>
      </Flex>
    ))
  );

  return (
    <Flex
      flexDirection="column"
      gap={isTabletSM ? 16 : 32}
      mb={74}
      ml={isTabletLG ? 0 : 48}
      width="100%"
    >
      {literatureList}
    </Flex>
  );
};

LiteratureList.propTypes = {
  literature: arrayOf(
    shape({
      id: string,
      link: string,
      titleText: string,
    })
  ).isRequired,
};

export default LiteratureList;
